import {
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Modal from "@mui/material/Modal";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";

const useStyles = makeStyles((theme) => ({
  tableCell: {
    paddingLeft: 0,
    paddingRight: 5,
  },
  actions: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    position: "absolute",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `30%`,
    left: `45%`,
    transform: `translate(-15%, -25%)`,
  },
  textField: {
    width: "100%",
  },
  iconRapper: {
    backgroundColor: theme.palette.gif.yellow.color,
    width: 30,
    height: 30,
    borderRadius: "100%",
  },
  icon: {
    marginTop: 5,
    marginLeft: 5,
    color: theme.palette.gif.yellow.dark,
    fontSize: 20,
  },
  closeIcon: {
    top: -15,
    left: 0,
    marginBottom:-25,
  },
  typography: {
    fontSize: 17,
    color: "#4B4B4B",
  },
  smallTypography: {
    maxWidth: 130,
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    width: 75,
  },
  button: {
    width: 75,
  },
}));

export default function LongTextPopUp(props) {
  const { open, setOpen, onSave, modelTitle, editable, value } = props;
  const classes = useStyles();
  const [longValue, setLongValue] = useState(value);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(!open)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Paper elevation={3} className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={1}>
            <div className={classes.iconRapper}>
              <EditRoundedIcon className={classes.icon} />
            </div>
          </Grid>
          <Grid item xs={10}>
            <Typography
              variant="subtitle2"
              className={classes.typography}
              gutterBottom
            >
              {modelTitle}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            {!editable && (
              <IconButton className={classes.closeIcon} onClick={()=>setOpen(!open)} size="large">
                <CancelIcon  style={{fontSize:30}}/>
              </IconButton>
            )}
          </Grid>
          <Grid item xs={12}>
            {!editable ? (
              <Typography
                variant="subtitle2"
                className={classes.typography}
                gutterBottom
              >
                {longValue}
              </Typography>
            ) : (
              <TextField
                disabled={!editable}
                value={longValue}
                multiline
                rows={6}
                maxRows={15}
                size="small"
                onChange={(e) => setLongValue(e.target.value)}
                className={classes.textField}
              />
            )}
          </Grid>
          <Grid item xs={4} />
          <Grid item className={classes.actions}>
            {editable && (
              <>
                <Button
                  disableElevation
                  variant="contained"
                  className={classes.button}
                  onClick={() => {
                    setOpen(!open);
                    setLongValue(value);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  className={classes.saveButton}
                  onClick={() => onSave(longValue)}
                >
                  Save
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
